import React from "react";
import "../styles/03-components/footer.scss";

export const Footer = () => {
  const handleLegalLink = (page: string) => {
    // TODO: Replace with actual legal page links
    const links = {
      agb: "/agb",
      datenschutz: "/datenschutz",
      impressum: "/impressum",
    };
    window.open(links[page as keyof typeof links], "_blank");
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <h3>OffTogether</h3>
            <p>
              Die Plattform, die Teamsportler:innen offline miteinander
              verbindet. Finde dein Match, spiele vor Ort, sammle Punkte.
            </p>
          </div>

          {/* Links */}
          {/*   <div className="footer-section">
            <h4>Rechtliches</h4>
            <ul className="footer-links">
              <li>
                <button
                  onClick={() => handleLegalLink("agb")}
                  className="footer-link"
                >
                  AGB
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLegalLink("datenschutz")}
                  className="footer-link"
                >
                  Datenschutz
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLegalLink("impressum")}
                  className="footer-link"
                >
                  Impressum
                </button>
              </li>
            </ul>
          </div> */}
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © 2025 GWI UG (haftungsbeschränkt). Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
